<template lang="">
  <div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">관리자 관리</a> &gt; <strong>관리자 리스트</strong></div>
			<h2 class="h_sub">관리자 관리</h2>
		</div>

    <AdminAccountManageForm/>

	</div>
</template>

<script>
import AdminAccountManageForm from '@/components/admin/account/AdminAccountManageForm.vue'

export default {
  components: {
    AdminAccountManageForm
  },
}
</script>

<style lang="">
    
</style>